export default __webpack_public_path__ + "static/media/b11.3b19cacb.png";